<template>
  <v-row>
    <v-col class="d-flex" cols="12" md="4" v-for="(campus, index) in statuses_campus_places" :key="index">
      <v-card max-height="500px" rounded="xl" outlined width="100%">
        <v-card-title>
          <h6 class="text-center mx-auto text-h6"> {{ campus.name_hostel }} </h6>
        </v-card-title>
        <v-card-subtitle class="text-center">
          <p>Занято / Всего</p>
        </v-card-subtitle>
        <v-card-text class="text-h4 text-center">
          <span>{{ campus.count_places.count_places_occupied }} /</span>
          <span>{{ campus.count_places.count_places_total }}</span>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
    import {mapGetters, mapState} from "vuex";

    export default {
        name: "CardsHostelStatuses",
        data: () => ({
        }),
        computed: {
            ...mapState({
                statuses_campus_places: state => state.placesInDormitories.statuses_campus_places,
            }),
            ...mapGetters({}),
        },
    }
</script>

<style scoped>

</style>